
















import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop, Watch } from 'vue-property-decorator'
import TaxesTable from '@/components/taxes/TaxesTable.vue'
import taxStore from '@/stores/TaxStore'
import Tax from '@/dto/taxes/Tax'
import { Routes } from '@/router/routes'

@Component({
  components: { TaxesTable },
})
export default class Taxes extends Vue {
  @Prop(String)
  taxId: string | null

  taxStore = taxStore
  isPending: boolean = false

  get taxes(): Tax[] {
    return this.taxStore.taxes
  }

  get isFullSplitter() {
    return this.$route.name === Routes.taxes
  }

  created() {
    if (this.taxes.length > 0) {
      return
    }

    this.isPending = true
    this.taxStore.loadTaxes().finally(() => (this.isPending = false))
  }

  @Watch('taxId', { immediate: true })
  selectTax(taxId: string | null) {
    this.taxStore.selectTax(taxId ? parseInt(taxId) : null)
  }
}
